import type { ApolloContext } from '../../../types';
import type { PubNubTask } from '../../../types/pubnubTypes';
import { upsertTaskForEngagement } from './common';

export const PubNubTaskUpdated = (
  obj: any,
  args: { task: PubNubTask },
  { client }: ApolloContext,
) => {
  upsertTaskForEngagement(client, args.task);
};
